import React from "react";
import { InfoSection } from "../../components";
import {
  homeObjThree,
  homeObjTwo,
  homeObjFour,
  homeObjOne,
  homeObjFive,
  homeObjSix,
  homeObjSeven,
  homeObjEight,
} from "./Data";

const Products = () => {
  return (
    <>
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjTwo} />
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjFour} />
      <InfoSection {...homeObjFive} />
      <InfoSection {...homeObjSix} />
      <InfoSection {...homeObjSeven} />
      <InfoSection {...homeObjEight} />
    </>
  );
};

export default Products;
